export default "__VITE_ASSET__DgNha7tn__"